module.exports = __webpack_public_path__ + "img/logo_row.2c8c8cab.svg";